import React, { Suspense } from "react";
import {
  MdShower, MdCheckroom, MdWc, MdLock, MdMonitorHeart, MdLightbulb, MdGpsFixed, MdCircle,
  MdDirectionsCar, MdLocationCity, MdWifi, MdChair, MdAir, MdLocalDrink, MdCoffee, MdLayers,
  MdMusicNote, MdSchool, MdVideocam, MdPeople, MdFitnessCenter, MdBeachAccess, MdLocalParking,
  MdPower, MdVolumeUp, MdDesktopWindows, MdRestaurant, MdDeviceThermostat, MdWbSunny,
  MdAccessTime, MdVerifiedUser, MdCameraAlt, MdPedalBike, MdChildCare, MdStar, MdWorkspacePremium,
  MdAutoAwesome, MdLocalFireDepartment, MdAcUnit, MdHeadphones, MdMic, MdMovie, MdMedication,
  MdMedicalServices, MdPark, MdWater, MdDirectionsWalk, MdCloud, MdSportsHandball,
} from "react-icons/md";

// Preloaded commonly-used icons for instant rendering
const preloadedIcons = {
  ShowerHead: MdShower, Shirt: MdCheckroom, Toilet: MdWc, Lock: MdLock,
  HeartPulse: MdMonitorHeart, Lightbulb: MdLightbulb, Crosshair: MdGpsFixed,
  Circle: MdCircle, Car: MdDirectionsCar, Building2: MdLocationCity, Wifi: MdWifi,
  Armchair: MdChair, Wind: MdAir, GlassWater: MdLocalDrink, Coffee: MdCoffee,
  Layers: MdLayers, Music: MdMusicNote, GraduationCap: MdSchool, Video: MdVideocam,
  Users: MdPeople, Dumbbell: MdFitnessCenter, Umbrella: MdBeachAccess,
  ParkingCircle: MdLocalParking, Plug: MdPower, Speaker: MdVolumeUp,
  Monitor: MdDesktopWindows, Utensils: MdRestaurant, Thermometer: MdDeviceThermostat,
  Sun: MdWbSunny, Clock: MdAccessTime, ShieldCheck: MdVerifiedUser,
  Camera: MdCameraAlt, Bike: MdPedalBike, Baby: MdChildCare, Star: MdStar,
  Crown: MdWorkspacePremium, Sparkles: MdAutoAwesome, Flame: MdLocalFireDepartment,
  Snowflake: MdAcUnit, Headphones: MdHeadphones, Mic: MdMic, Clapperboard: MdMovie,
  Pill: MdMedication, Stethoscope: MdMedicalServices, TreePine: MdPark,
  Waves: MdWater, Footprints: MdDirectionsWalk, Cloud: MdCloud,
};

function LazyMaterialIcon({ name, className }) {
  const [Icon, setIcon] = React.useState(() => preloadedIcons[name] || null);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (Icon || error) return;
    let cancelled = false;
    import("react-icons/md")
      .then((mod) => {
        if (cancelled) return;
        const Found = mod[`Md${name}`];
        if (Found) {
          setIcon(() => Found);
        } else {
          setError(true);
        }
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => { cancelled = true; };
  }, [name]);

  if (Icon) return <Icon className={className} />;
  if (error) return <MdCircle className={className} />;
  return <MdCircle className={`${className} opacity-30`} />;
}

function Fallback() {
  return <MdCircle className="h-4 w-4 opacity-30" />;
}

export function AmenityIcon({ name, className = "h-4 w-4" }) {
  // Preloaded icons render instantly
  if (preloadedIcons[name]) {
    const Icon = preloadedIcons[name];
    return <Icon className={className} />;
  }
  // Unknown icon: lazy-load from Material Icons
  return (
    <Suspense fallback={<Fallback />}>
      <LazyMaterialIcon name={name} className={className} />
    </Suspense>
  );
}
